import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import UserService from '@/request/user/user'
import OrgService from '@/request/user/org'
import OrgAdminService from '@/request/user/orgAdmin'
import AuthorService from '@/request/author/author'
import PermissionService from '@/request/user/permission'
import Cookies from 'js-cookie'
import websocketStorePlugin from '@/plugins/websocket-store'

Vue.use(Vuex)

const state = {
  tokens: {
    client_token: null,
    access_token: null,
    refresh_token: null
  },
  user: null,
  ws: null,
  isadmin: false,
  adminOrgs: [],
  hospitals: [],
  permissions: [],
  routers: []
}

const mutations = {
  updateTokens (state, tokens) {
    for (let key in state.tokens) {
      if (tokens.hasOwnProperty(key)) {
        state.tokens[key] = tokens[key]
      }
    }
  },
  updateUser (state, user) {
    state.user = user
  },
  updateIsadmin (state, isadmin) {
    state.isadmin = isadmin || false
  },
  updateAdminOrgs (state, oids) {
    state.adminOrgs = oids || []
  },
  updateHospitals (state, hospitals) {
    state.hospitals = hospitals || []
  },
  updatePermissions (state, permissions) {
    state.permissions = permissions || []
  },
  updateRouters (state, routers) {
    state.routers = routers || []
  },
  setWs: function (state, ws) {
    state.ws = ws || null
  }
}

const actions = {
  tokens ({commit}, payload) {
    commit('updateTokens', payload)
  },
  routers ({commit}, payload) {
    commit('updateRouters', payload)
  },
  user ({commit}, payload) {
    return new Promise(resolve => {
      commit('updateUser', payload)
      let promise1 = UserService.isadmin().then(res => {
        commit('updateIsadmin', res.result)
      })
      let promise2 = OrgAdminService.isAdmin().then(res => {
        commit('updateAdminOrgs', res.result)
      })
      let promise3 = OrgService.listOrg({
        parents: 1,
        descendant: 1,
        typeSns: 'lx0001001'
      }).then(res => {
        commit('updateHospitals', res.result)
      })
      let promise4 = PermissionService.list().then(res => {
        commit('updatePermissions', res.result)
      })
      Promise.all([promise1, promise2, promise3, promise4]).then(() => {
        resolve(true)
      })
    })
  },
  clientToken ({commit}) {
    let client = Cookies.get('client_token')
    if (!client) {
      AuthorService.client().then(data => {
        let token = data['access_token']
        Cookies.set('client_token', token)
        commit('updateTokens', {
          client_token: token
        })
      })
    } else {
      commit('updateTokens', {
        client_token: client
      })
    }
  },
  refreshToken ({commit, state}) {
    let rToken = state.tokens.refresh_token || Cookies.get('refresh_token')
    return new Promise(function (resolve, reject) {
      if (!rToken) {
        reject(new Error('刷新失败'))
      } else {
        AuthorService.refresh(rToken).then(author => {
          let user_token = author['access_token']
          let refresh_token = author['access_token']
          Cookies.set('user_token', user_token)
          Cookies.set('isLogged', 1)
          Cookies.set('refresh_token', refresh_token)
          commit('updateTokens', {
            access_token: user_token,
            refresh_token: refresh_token
          })
          resolve('刷新成功')
        }, () => {
          Cookies.remove('user_token')
          Cookies.remove('refresh_token')
          Cookies.remove('isLogged')
          commit('updateTokens', {
            access_token: null,
            refresh_token: null
          })
          reject(new Error('刷新失败'))
        })
      }
    })
  }
}

const getters = {
  tokens (state) {
    return state.tokens
  },
  user (state) {
    return state.user
  },
  adminOrgs (state) {
    return state.adminOrgs
  },
  isadmin (state) {
    return state.isadmin
  },
  hospitals (state) {
    return state.hospitals
  },
  permissions (state) {
    return state.permissions
  },
  routers (state) {
    return state.routers
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [websocketStorePlugin()],
  modules: modules
})
